
import {computed, defineComponent, onBeforeMount, ref, watch} from 'vue';
import {UserRoles} from "@/models/user.model";
import AlertViewer from "@/components/alerts/AlertViewer.vue";
import DialogViewer from "@/components/DialogViewer.vue";
import {useAuthStore} from "@/store/auth";
import {storeToRefs} from "pinia";
import {useRoute, useRouter} from "vue-router";
import {useAlertStore} from "@/store/alert";
import AdminCockpit from "@/components/admin/admin_cockpit/AdminCockpit.vue";
import {useDialogStore} from "@/store/dialog";
import {DialogTypes} from "@/interfaces/dialog";
import ButtonRegular from "@/components/buttons/ButtonRegular.vue";
import {VOffline} from 'v-offline';
import {AppConfigurator} from "@/configuration/appConfigurator";
import {useAppStore} from "@/store/app";

export default defineComponent({
  name: 'App',
  components: {
    ButtonRegular,
    AlertViewer,
    DialogViewer,
    AdminCockpit,
    VOffline
  },
  setup() {
    const appStore = useAppStore();
    const authStore = useAuthStore();
    const alertStore = useAlertStore();
    const dialogStore = useDialogStore();
    const router = useRouter();
    const route = useRoute();
    const {user} = storeToRefs(authStore);
    const {cursorX, cursorY} = storeToRefs(appStore);

    const online = ref(false);

    const displayLogoutPrompt = computed(() => {
      return user.value.role === UserRoles.ADMININISTRATOR && screen.width <= 760;
    })

    function logout() {
      authStore.logout();
      router.push({name: "login"});
    }

    function onNetworkChange(val: boolean) {
      if (!val) {
        dialogStore.currentDialog! = {
          type: DialogTypes.NO_BUTTON,
          title: "Geen internet",
          body: "Het lijkt erop dat je geen internettoegang hebt.",
          lock: true
        }
      }
      else if (!online.value) {
        dialogStore.currentDialog = null;
      }
      online.value = val;
    }

    function onMouseMove(event: any) {
      cursorX.value = event.clientX;
      cursorY.value = event.clientY;
    }

    watch(() => user.value.username, () => {
      document.title = "Ritstapp - Inloggen";
      if (authStore.isAuthenticatedLocal()) {
        document.title = `Ritstapp - ${user.value.companyName}`;
      }
    })

    /* Clear alerts on route change. */
    watch(route, () => {
      alertStore.clearAlerts();
    })

    onBeforeMount(() => {
      document.title = "Ritstapp - Inloggen";

      const appConfigurator = AppConfigurator.getInstance();
      appConfigurator.applyConfiguration();
    })

    return {
      user, authStore, displayLogoutPrompt, cursorX, cursorY,
      onNetworkChange, logout, onMouseMove,
      UserRoles
    }
  },
})
